import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlBalancete = '/service/balanceteDespesaRestService/'

class DespesasPorRubricaService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    consultar(data) {
        let json = {
            administracao: data.administracao,
            exercicio: data.exercicio,
            mes: data.mes,
            recursoContabil: data.recursoContabil,
            codigoDestinacao: data.codigoDestinacao,
            orgaoContabil: data.orgaoContabil,
            unidadeContabil: data.unidadeContabil,
        }

        return this.conex.post(urlBalancete + 'recuperaDespesasPorRubricaRest/', JSON.stringify(json))
    }
}

export default DespesasPorRubricaService
